import { FC, useContext, useState } from "react";
import NotificationDispatch, {
  showErrorNotification,
  showSuccessNotification,
} from "../../context/notificationContext";
import { useI18n } from "../../hooks/useTranslations";
import { useHighwayPassesApi } from "../../http/highwayPasses/api";
import { UpsertHighwayPass } from "../../http/highwayPasses/types";
import ModalDialog from "../ui/ModalDialog";
import HighwayPassForm, { HighwayPassFormBody } from "./HighwayPassForm";

interface CreateHighwayPassDialogProps {
  carId?: string;
  onClose: (success?: boolean) => void;
}

const CreateHighwayPassDialog: FC<CreateHighwayPassDialogProps> = ({ carId, onClose }) => {
  const i18n = useI18n();
  const dispatch = useContext(NotificationDispatch);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const highwayPassesApi = useHighwayPassesApi();

  const onSubmit = async (formData: HighwayPassFormBody) => {
    const body: UpsertHighwayPass = {
      carId: carId ?? formData.car.id,
      nr: formData.nr,
      startDate: formData.startDate,
      endDate: formData.endDate,
    };

    setIsSubmitting(true);
    try {
      await highwayPassesApi.insertAdminHighwayPass(body);
      dispatch(showSuccessNotification(i18n.t));
      onClose(true);
    } catch (error) {
      dispatch(showErrorNotification(i18n, error));
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <ModalDialog onClose={onClose} title={i18n.t.highwayPasses.new}>
      <HighwayPassForm isDisabled={isSubmitting} onSubmit={onSubmit} allowSelectCar={!carId} />
    </ModalDialog>
  );
};

export default CreateHighwayPassDialog;
